import { __extends } from "tslib";
var AlreadyDisposedError = /** @class */ (function (_super) {
    __extends(AlreadyDisposedError, _super);
    function AlreadyDisposedError() {
        return _super.call(this, "IFrame is already disposed. Please create a new one and try again.") || this;
    }
    return AlreadyDisposedError;
}(Error));
export { AlreadyDisposedError };
var NotLoadedError = /** @class */ (function (_super) {
    __extends(NotLoadedError, _super);
    function NotLoadedError() {
        return _super.call(this, "IFrame is not loaded. Please call load() and try again.") || this;
    }
    return NotLoadedError;
}(Error));
export { NotLoadedError };
